module.exports = __webpack_public_path__ + "5afa590791a11007277f3434aa7d34e4.jpg";